import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import * as authActions from 'action/auth'
// import Header from 'component/layouts/Header'
import NewHeader from 'component/layouts/newHeader/Header'
import { ToastContainer } from 'react-toastify'

function RequireAuth(ComposedComponent, showHeader = true) {
  class Authentication extends Component {
    static propTypes = {
      auth: PropTypes.object.isRequired,
      dispatch: PropTypes.func,
      logout: PropTypes.func.isRequired,
      checkPath: PropTypes.func.isRequired,
      location: PropTypes.object.isRequired,
      allowAccess: PropTypes.func,
      translate: PropTypes.func.isRequired,
      menu: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const { auth, allowAccess } = this.props

      this.checkAuth(auth.isAuthenticated)

      allowAccess()
    }

    componentWillUpdate(nextProps) {
      this.checkAuth(nextProps.auth.isAuthenticated)
    }

    checkAuth(isAuthenticated) {
      if (!isAuthenticated) {
        this.props.dispatch(push('/login'))
      }
    }

    render() {
      const { auth, logout, translate, menu } = this.props

      return (
        <div>
          {showHeader && (
            <NewHeader
              auth={auth}
              logout={logout}
              translate={translate}
              menu={menu}
            />
          )}

          {auth.isFunctionAllowed && auth.user && (
            <div className='margin-left-main-container'>
              <ComposedComponent {...this.props} />
            </div>
          )}
          <ToastContainer newestOnTop />
        </div>
      )
    }
  }

  function mapStateToProps({ auth, menuReducer }) {
    return {
      auth,
      menu: menuReducer.menu,
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators(authActions, dispatch)
  }

  /*
   * Connects component to I18next
   */
  const AuthenticationTranslated = translate(null, {
    wait: true,
    translateFuncName: 'translate',
  })(Authentication)

  return connect(mapStateToProps, mapDispatchToProps)(AuthenticationTranslated)
}

export default RequireAuth
